// extracted by mini-css-extract-plugin
module.exports = {"music":"Music_music__OAmaz","musicInnerContainer":"Music_musicInnerContainer__3Yg93","musicLoadingContainer":"Music_musicLoadingContainer__15KwX"};